var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("WzModuleVisioAPZ"),
      _vm._v(" "),
      _vm.numPlaceOccupe
        ? _c(
            "div",
            { staticClass: "wz_viewportChats" },
            [
              _c(
                "v-layout",
                {
                  staticClass: "wz_viewportChat",
                  class: {
                    wz_attenteActif: _vm.listeAttente.length,
                    wz_attenteInactif: !_vm.listeAttente.length
                  },
                  attrs: { row: "", wrap: "" }
                },
                _vm._l(_vm.pupitreViewsData, function(pupitre, i) {
                  return _c(
                    "v-flex",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showingPupitre[i],
                          expression: "showingPupitre[i]"
                        }
                      ],
                      key: i,
                      staticClass: "fill-height pa-0",
                      class: {
                        viewSelected: _vm.placeFocus == i + 1,
                        "divisHauteur xs6": _vm.pupitreViewStatus == 4,
                        xs6: _vm.pupitreViewStatus == 2,
                        xs12: _vm.pupitreViewStatus == 1
                      }
                    },
                    [
                      _c(
                        "drop",
                        {
                          staticClass: "drop",
                          class: { over: _vm.over[i] },
                          on: {
                            drop: function(data) {
                              return _vm.handleDrop({
                                dataDrop: data,
                                statusView: pupitre.view.viewStatus,
                                place: i + 1,
                                idVisiteurPlace: pupitre.view.visiteurID,
                                menuSelectedPlace:
                                  pupitre.view && pupitre.view.visiteurDatas
                                    ? pupitre.view.visiteurDatas.menuSelected
                                    : "visitorCard",
                                reponseCobrowsingPlace:
                                  pupitre.view && pupitre.view.visiteurDatas
                                    ? pupitre.view.visiteurDatas
                                        .reponseCobrowsing
                                    : false
                              })
                            },
                            dragover: function(data) {
                              return _vm.handleDragStat({
                                index: i,
                                dataDrop: data,
                                status: true
                              })
                            },
                            dragleave: function(data) {
                              return _vm.handleDragStat({
                                index: i,
                                dataDrop: data,
                                status: false
                              })
                            }
                          }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "wz_contentChatView",
                              class: {
                                "view_border--bottom":
                                  _vm.pupitreViewStatus == 4 &&
                                  (i == 0 || i == 1),
                                "view_border--right":
                                  (_vm.pupitreViewStatus == 2 && i == 0) ||
                                  (_vm.pupitreViewStatus == 4 &&
                                    (i == 0 || i == 2))
                              }
                            },
                            [
                              pupitre.view.viewStatus
                                ? _c("wz-view-chat", {
                                    attrs: {
                                      dragOverStatus: _vm.over[i],
                                      dragOverElement: _vm.elementsDrag,
                                      datasViewPupitre: pupitre.view,
                                      placesPupitre: _vm.numPlaceOccupe
                                    },
                                    on: {
                                      supVisiteurFile:
                                        _vm.supVisiteurFileAttente
                                    },
                                    nativeOn: {
                                      click: function($event) {
                                        return _vm.focusView({
                                          view: i + 1,
                                          visiteurID: pupitre.view.visiteurID
                                        })
                                      }
                                    }
                                  })
                                : _c("div", { staticClass: "bigNum" }, [
                                    _c("span", [_vm._v(_vm._s(i + 1))])
                                  ])
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  )
                }),
                1
              ),
              _vm._v(" "),
              _vm.listeAttente.length > 0
                ? _c("wz-view-attente", {
                    attrs: {
                      datasFileAttente: _vm.listeAttente,
                      pupitreData: _vm.pupitreViewsData
                    },
                    on: { supVisiteurFile: _vm.supVisiteurFileAttente },
                    nativeOn: {
                      click: function($event) {
                        return _vm.focusView({ view: null, visiteurID: null })
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _c(
            "v-card",
            { attrs: { height: "100%" } },
            [
              _c(
                "v-container",
                { attrs: { fluid: "", "grid-list-lg": "" } },
                [
                  _c(
                    "v-alert",
                    {
                      attrs: {
                        outline: "",
                        color: "secondary",
                        icon: "info",
                        value:
                          !_vm.datasFilterVisiteursArray.length &&
                          _vm.status == "offline",
                        transition: "scale-transition"
                      }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.$t("noTargetingOffline")) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", md3: "" } },
                        [
                          _c("v-img", {
                            attrs: {
                              src:
                                _vm.domaine.indexOf("targetfirst") !== -1
                                  ? _vm.domaine + "/static/booster.png"
                                  : _vm.domaine +
                                    "/watcheezy/static/booster.png",
                              height: !_vm.$vuetify.breakpoint.smAndDown
                                ? "250px"
                                : "60px",
                              contain: ""
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-flex", { attrs: { xs12: "", md7: "" } }, [
                        _c(
                          "div",
                          [
                            _c(
                              "section",
                              [
                                _c(
                                  "h2",
                                  { staticClass: "headline accent--text" },
                                  [
                                    _c("div", [
                                      _c("p", [
                                        _vm._v(
                                          _vm._s(_vm.$t("realTimeAnalysis"))
                                        )
                                      ])
                                    ])
                                  ]
                                ),
                                _vm._v(" "),
                                _c("v-progress-linear", {
                                  attrs: {
                                    color: "accent",
                                    indeterminate: true
                                  }
                                }),
                                _vm._v(" "),
                                _c(
                                  "blockquote",
                                  { staticClass: "blockquote secondary--text" },
                                  [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          _vm._f("cap")(
                                            _vm.$tc(
                                              "targetedVisitors",
                                              _vm.datasFilterVisiteursArray
                                                .length,
                                              {
                                                count:
                                                  _vm.datasFilterVisiteursArray
                                                    .length
                                              }
                                            )
                                          )
                                        ) +
                                        "\n                " +
                                        _vm._s(_vm.$t("outOf")) +
                                        "\n                " +
                                        _vm._s(
                                          _vm.$tc(
                                            "visitors",
                                            _vm.listeAllVisiteurs.length,
                                            { count: _vm.nbVisitors }
                                          )
                                        ) +
                                        "\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "title text-xs-center" }),
                            _vm._v(" "),
                            _c("blockquote", { staticClass: "blockquote" }, [
                              _c("div", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t("noIncomingChats") +
                                      ", " +
                                      _vm.$t("checkActiveFilters")
                                  )
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _vm.checkPermission("NO_PEONS_NOR_AGENTS")
                              ? _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      block: "",
                                      to: { path: "/target/filters" },
                                      outline: "",
                                      color: "secondary"
                                    }
                                  },
                                  [
                                    _c("v-icon", { attrs: { left: "" } }, [
                                      _vm._v("track_changes")
                                    ]),
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.$t("setUpFilters")) +
                                        "\n            "
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "290" },
          model: {
            value: _vm.dialogChangeSlot,
            callback: function($$v) {
              _vm.dialogChangeSlot = $$v
            },
            expression: "dialogChangeSlot"
          }
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "primary white--text subheading" },
                [_vm._v(_vm._s(_vm.$t("changePlace")))]
              ),
              _vm._v(" "),
              _vm.dataEchangePlace
                ? _c("v-card-text", [
                    _vm._v(
                      "\n        " + _vm._s(_vm.$t("changePlaceContent1")) + " "
                    ),
                    _c("b", [_vm._v(_vm._s(_vm.dataEchangePlace.place))]),
                    _c("br"),
                    _vm._v(
                      "\n        " + _vm._s(_vm.$t("changePlaceContent2")) + " "
                    ),
                    _c("b", [
                      _vm._v(_vm._s(_vm.dataEchangePlace.idVisiteurPlace))
                    ]),
                    _vm._v("."),
                    _c("br"),
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("askChangePlace")) +
                        "\n      "
                    )
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "blue--text darken-1",
                      attrs: { flat: "" },
                      on: {
                        click: function($event) {
                          _vm.dialogChangeSlot = false
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("no")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "blue--text darken-1",
                      attrs: { flat: "" },
                      on: {
                        click: function($event) {
                          return _vm.echangePlace()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("yes")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-cc880250", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc880250","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/trafic/Chatting.vue
// module id = null
// module chunks = 